module.exports = __webpack_public_path__ + "media/images/menu/perseus-deb03cbaae3545c05d4a93c06257b25a.jpg";